export default "__VITE_ASSET__BxsdRCKd__"